import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';

@Component({
	selector: 'app-intro',
	templateUrl: './intro.component.html',
	styleUrls: ['./intro.component.scss']
})

/**
 * (c) it.x informationssysteme gmbh, Alle Rechte vorbehalten.
 *
 * Header Component.
 */
export class IntroComponent
{
	/**
	 * Environment.
	 */
	public environment = environment;

	/**
	 * State: Start Intro.
	 */
	public introStarted = false;

	/**
	 * Constructor.
	 */
	public constructor(
		private router: Router
	)
	{}

	/**
	 * Eventhandler: Click on pin.
	 */
	public onClick()
	{
		this.introStarted = true;
		setTimeout(() => {
			if (localStorage.getItem('SYNC_COMPLETE') && this.environment.webBuild !== true)
			{
				this.router.navigateByUrl('/portal/stage');
			}
			else
			{
				this.router.navigateByUrl('/sync');
			}
		}, 700);
	}
}



// WEBPACK FOOTER //
// /var/data/workspace/hess/hess_smart_city_web/src/app/components/intro/intro.component.ts